/**tipando os tipos */

import { apiSlice } from "../../app/apiSlice";
import configUrls from "../../config/configUrls";


// Definição do tipo para os parâmetros de login
interface LoginCredentials {
    username: string;
    password: string;
}

// Definição do tipo para os resultados da API
interface LoginResponse {
    token: string;
    tipo: string;
    id: string;
    setorId: string;
    setorNome: string;
    tipoSite: string;
}


const endpointUrl = configUrls.SITE_LOGIN_EP 

function login({ username, password }: LoginCredentials) {
    return {
        url: `${endpointUrl}/login`,
        method: "POST",
        body: {
            login: username, password: password
        },
    }
}

function refreshToken({ oldToken }: { oldToken: string }) {
    return {
        url: endpointUrl + "/refresh",
        method: "POST",
        body: {
            token: oldToken,
        },
    };
}

export const loginApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ mutation }) => ({
        Login: mutation<LoginResponse, LoginCredentials>(
            {
                query: login,
                invalidatesTags: ["Login"]
            }),

        refreshToken: mutation<LoginResponse, { oldToken: string }>(
            {
                query: refreshToken,
                invalidatesTags: ["Login"]
            }),
            
    })
})

export const {
    useLoginMutation,
    useRefreshTokenMutation
} = loginApiSlice;


